
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("9pqpz"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("1RPx3"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("2HmaY"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("dVCdB"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("cPOgS"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("389X8"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("5DHgn"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("dwtzR"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("fkS1Z"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("4jf5l"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("eyi3k"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("frKvj"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("9pqpz", function(module, exports) {

let $6d9aef9f943b884f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d9aef9f943b884f$var$load("2YffH"),
    $6d9aef9f943b884f$var$load("1o23t"),
    $6d9aef9f943b884f$var$load("lqFMg"),
    $6d9aef9f943b884f$var$load("4YQJ5"),
    $6d9aef9f943b884f$var$load("jwoNh"),
    $6d9aef9f943b884f$var$load("l1nJ9"),
    $6d9aef9f943b884f$var$load("iQ0Jm"),
    $6d9aef9f943b884f$var$load("eBRUf"),
    $6d9aef9f943b884f$var$load("5eNHu"),
    $6d9aef9f943b884f$var$load("6iBAZ"),
    $6d9aef9f943b884f$var$load("h4Nf7"),
    $6d9aef9f943b884f$var$load("7f9Fz"),
    $6d9aef9f943b884f$var$load("8YSo7"),
    $6d9aef9f943b884f$var$load("e7ZUf"),
    $6d9aef9f943b884f$var$load("gL8bn"),
    $6d9aef9f943b884f$var$load("g9CVe"),
    $6d9aef9f943b884f$var$load("djHM5"),
    $6d9aef9f943b884f$var$load("eJQji"),
    $6d9aef9f943b884f$var$load("6wr18"),
    $6d9aef9f943b884f$var$load("kjZZD"),
    $6d9aef9f943b884f$var$load("gizWr"),
    $6d9aef9f943b884f$var$load("4PUiY"),
    $6d9aef9f943b884f$var$load("dRpV3"),
    $6d9aef9f943b884f$var$load("ffEVr"),
    $6d9aef9f943b884f$var$load("dTsOE"),
    $6d9aef9f943b884f$var$load("jwTn5"),
    $6d9aef9f943b884f$var$load("aYdgM"),
    $6d9aef9f943b884f$var$load("jY21r"),
    $6d9aef9f943b884f$var$load("2vAWg"),
    $6d9aef9f943b884f$var$load("7cABH"),
    $6d9aef9f943b884f$var$load("7KZeZ"),
    $6d9aef9f943b884f$var$load("8Vzcw"),
    $6d9aef9f943b884f$var$load("co52j"),
    $6d9aef9f943b884f$var$load("2uVTT"),
    $6d9aef9f943b884f$var$load("hhss7"),
    $6d9aef9f943b884f$var$load("Wowvf"),
    $6d9aef9f943b884f$var$load("4Nzvy"),
    $6d9aef9f943b884f$var$load("hJpvQ"),
    $6d9aef9f943b884f$var$load("bIPPg"),
    $6d9aef9f943b884f$var$load("lnKog"),
    $6d9aef9f943b884f$var$load("h3ABO"),
    $6d9aef9f943b884f$var$load("kC80R"),
    $6d9aef9f943b884f$var$load("7EorR"),
    $6d9aef9f943b884f$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("1RPx3", function(module, exports) {

let $15c2b6de92ffa4a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $15c2b6de92ffa4a1$var$load("2YffH"),
    $15c2b6de92ffa4a1$var$load("1o23t"),
    $15c2b6de92ffa4a1$var$load("lqFMg"),
    $15c2b6de92ffa4a1$var$load("4YQJ5"),
    $15c2b6de92ffa4a1$var$load("jwoNh"),
    $15c2b6de92ffa4a1$var$load("l1nJ9"),
    $15c2b6de92ffa4a1$var$load("iQ0Jm"),
    $15c2b6de92ffa4a1$var$load("eBRUf"),
    $15c2b6de92ffa4a1$var$load("5eNHu"),
    $15c2b6de92ffa4a1$var$load("6iBAZ"),
    $15c2b6de92ffa4a1$var$load("h4Nf7"),
    $15c2b6de92ffa4a1$var$load("7f9Fz"),
    $15c2b6de92ffa4a1$var$load("8YSo7"),
    $15c2b6de92ffa4a1$var$load("e7ZUf"),
    $15c2b6de92ffa4a1$var$load("gL8bn"),
    $15c2b6de92ffa4a1$var$load("g9CVe"),
    $15c2b6de92ffa4a1$var$load("djHM5"),
    $15c2b6de92ffa4a1$var$load("eJQji"),
    $15c2b6de92ffa4a1$var$load("6wr18"),
    $15c2b6de92ffa4a1$var$load("kjZZD"),
    $15c2b6de92ffa4a1$var$load("gizWr"),
    $15c2b6de92ffa4a1$var$load("4PUiY"),
    $15c2b6de92ffa4a1$var$load("dRpV3"),
    $15c2b6de92ffa4a1$var$load("ffEVr"),
    $15c2b6de92ffa4a1$var$load("dTsOE"),
    $15c2b6de92ffa4a1$var$load("jwTn5"),
    $15c2b6de92ffa4a1$var$load("aYdgM"),
    $15c2b6de92ffa4a1$var$load("jY21r"),
    $15c2b6de92ffa4a1$var$load("2vAWg"),
    $15c2b6de92ffa4a1$var$load("7cABH"),
    $15c2b6de92ffa4a1$var$load("7KZeZ"),
    $15c2b6de92ffa4a1$var$load("8Vzcw"),
    $15c2b6de92ffa4a1$var$load("co52j"),
    $15c2b6de92ffa4a1$var$load("2uVTT"),
    $15c2b6de92ffa4a1$var$load("hhss7"),
    $15c2b6de92ffa4a1$var$load("Wowvf"),
    $15c2b6de92ffa4a1$var$load("4Nzvy"),
    $15c2b6de92ffa4a1$var$load("hJpvQ"),
    $15c2b6de92ffa4a1$var$load("bIPPg"),
    $15c2b6de92ffa4a1$var$load("lnKog"),
    $15c2b6de92ffa4a1$var$load("h3ABO"),
    $15c2b6de92ffa4a1$var$load("kC80R"),
    $15c2b6de92ffa4a1$var$load("7EorR"),
    $15c2b6de92ffa4a1$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("2HmaY", function(module, exports) {

let $1f70cca3c10264ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1f70cca3c10264ed$var$load("2YffH"),
    $1f70cca3c10264ed$var$load("1o23t"),
    $1f70cca3c10264ed$var$load("lqFMg"),
    $1f70cca3c10264ed$var$load("4YQJ5"),
    $1f70cca3c10264ed$var$load("jwoNh"),
    $1f70cca3c10264ed$var$load("l1nJ9"),
    $1f70cca3c10264ed$var$load("iQ0Jm"),
    $1f70cca3c10264ed$var$load("eBRUf"),
    $1f70cca3c10264ed$var$load("5eNHu"),
    $1f70cca3c10264ed$var$load("6iBAZ"),
    $1f70cca3c10264ed$var$load("h4Nf7"),
    $1f70cca3c10264ed$var$load("7f9Fz"),
    $1f70cca3c10264ed$var$load("8YSo7"),
    $1f70cca3c10264ed$var$load("e7ZUf"),
    $1f70cca3c10264ed$var$load("gL8bn"),
    $1f70cca3c10264ed$var$load("g9CVe"),
    $1f70cca3c10264ed$var$load("djHM5"),
    $1f70cca3c10264ed$var$load("eJQji"),
    $1f70cca3c10264ed$var$load("6wr18"),
    $1f70cca3c10264ed$var$load("kjZZD"),
    $1f70cca3c10264ed$var$load("gizWr"),
    $1f70cca3c10264ed$var$load("4PUiY"),
    $1f70cca3c10264ed$var$load("dRpV3"),
    $1f70cca3c10264ed$var$load("ffEVr"),
    $1f70cca3c10264ed$var$load("dTsOE"),
    $1f70cca3c10264ed$var$load("jwTn5"),
    $1f70cca3c10264ed$var$load("aYdgM"),
    $1f70cca3c10264ed$var$load("jY21r"),
    $1f70cca3c10264ed$var$load("2vAWg"),
    $1f70cca3c10264ed$var$load("7cABH"),
    $1f70cca3c10264ed$var$load("7KZeZ"),
    $1f70cca3c10264ed$var$load("8Vzcw"),
    $1f70cca3c10264ed$var$load("co52j"),
    $1f70cca3c10264ed$var$load("2uVTT"),
    $1f70cca3c10264ed$var$load("hhss7"),
    $1f70cca3c10264ed$var$load("Wowvf"),
    $1f70cca3c10264ed$var$load("4Nzvy"),
    $1f70cca3c10264ed$var$load("hJpvQ"),
    $1f70cca3c10264ed$var$load("bIPPg"),
    $1f70cca3c10264ed$var$load("lnKog"),
    $1f70cca3c10264ed$var$load("h3ABO"),
    $1f70cca3c10264ed$var$load("kC80R"),
    $1f70cca3c10264ed$var$load("7EorR"),
    $1f70cca3c10264ed$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("dVCdB", function(module, exports) {

let $a23e3e9c6a450dd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a23e3e9c6a450dd9$var$load("e7ZUf"),
    $a23e3e9c6a450dd9$var$load("gL8bn"),
    $a23e3e9c6a450dd9$var$load("2YffH"),
    $a23e3e9c6a450dd9$var$load("lqFMg"),
    $a23e3e9c6a450dd9$var$load("4YQJ5"),
    $a23e3e9c6a450dd9$var$load("jwoNh"),
    $a23e3e9c6a450dd9$var$load("hJpvQ"),
    $a23e3e9c6a450dd9$var$load("l1nJ9"),
    $a23e3e9c6a450dd9$var$load("eBRUf"),
    $a23e3e9c6a450dd9$var$load("5eNHu"),
    $a23e3e9c6a450dd9$var$load("6iBAZ"),
    $a23e3e9c6a450dd9$var$load("h4Nf7"),
    $a23e3e9c6a450dd9$var$load("7f9Fz"),
    $a23e3e9c6a450dd9$var$load("8YSo7"),
    $a23e3e9c6a450dd9$var$load("g9CVe"),
    $a23e3e9c6a450dd9$var$load("djHM5"),
    $a23e3e9c6a450dd9$var$load("eJQji"),
    $a23e3e9c6a450dd9$var$load("6wr18"),
    $a23e3e9c6a450dd9$var$load("kjZZD"),
    $a23e3e9c6a450dd9$var$load("gizWr"),
    $a23e3e9c6a450dd9$var$load("4PUiY"),
    $a23e3e9c6a450dd9$var$load("dRpV3"),
    $a23e3e9c6a450dd9$var$load("ffEVr"),
    $a23e3e9c6a450dd9$var$load("dTsOE"),
    $a23e3e9c6a450dd9$var$load("jwTn5"),
    $a23e3e9c6a450dd9$var$load("aYdgM"),
    $a23e3e9c6a450dd9$var$load("jY21r"),
    $a23e3e9c6a450dd9$var$load("2vAWg"),
    $a23e3e9c6a450dd9$var$load("7cABH"),
    $a23e3e9c6a450dd9$var$load("7KZeZ"),
    $a23e3e9c6a450dd9$var$load("8Vzcw"),
    $a23e3e9c6a450dd9$var$load("co52j"),
    $a23e3e9c6a450dd9$var$load("bIPPg"),
    $a23e3e9c6a450dd9$var$load("2uVTT"),
    $a23e3e9c6a450dd9$var$load("hhss7"),
    $a23e3e9c6a450dd9$var$load("Wowvf"),
    $a23e3e9c6a450dd9$var$load("4Nzvy"),
    $a23e3e9c6a450dd9$var$load("h3ABO"),
    $a23e3e9c6a450dd9$var$load("kC80R"),
    $a23e3e9c6a450dd9$var$load("7EorR"),
    $a23e3e9c6a450dd9$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("cPOgS", function(module, exports) {

let $95813e40a91b94d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $95813e40a91b94d6$var$load("e7ZUf"),
    $95813e40a91b94d6$var$load("gL8bn"),
    $95813e40a91b94d6$var$load("2YffH"),
    $95813e40a91b94d6$var$load("lqFMg"),
    $95813e40a91b94d6$var$load("4YQJ5"),
    $95813e40a91b94d6$var$load("jwoNh"),
    $95813e40a91b94d6$var$load("hJpvQ"),
    $95813e40a91b94d6$var$load("l1nJ9"),
    $95813e40a91b94d6$var$load("eBRUf"),
    $95813e40a91b94d6$var$load("5eNHu"),
    $95813e40a91b94d6$var$load("6iBAZ"),
    $95813e40a91b94d6$var$load("h4Nf7"),
    $95813e40a91b94d6$var$load("7f9Fz"),
    $95813e40a91b94d6$var$load("8YSo7"),
    $95813e40a91b94d6$var$load("g9CVe"),
    $95813e40a91b94d6$var$load("djHM5"),
    $95813e40a91b94d6$var$load("eJQji"),
    $95813e40a91b94d6$var$load("6wr18"),
    $95813e40a91b94d6$var$load("kjZZD"),
    $95813e40a91b94d6$var$load("gizWr"),
    $95813e40a91b94d6$var$load("4PUiY"),
    $95813e40a91b94d6$var$load("dRpV3"),
    $95813e40a91b94d6$var$load("ffEVr"),
    $95813e40a91b94d6$var$load("dTsOE"),
    $95813e40a91b94d6$var$load("jwTn5"),
    $95813e40a91b94d6$var$load("aYdgM"),
    $95813e40a91b94d6$var$load("jY21r"),
    $95813e40a91b94d6$var$load("2vAWg"),
    $95813e40a91b94d6$var$load("7cABH"),
    $95813e40a91b94d6$var$load("7KZeZ"),
    $95813e40a91b94d6$var$load("8Vzcw"),
    $95813e40a91b94d6$var$load("co52j"),
    $95813e40a91b94d6$var$load("bIPPg"),
    $95813e40a91b94d6$var$load("2uVTT"),
    $95813e40a91b94d6$var$load("hhss7"),
    $95813e40a91b94d6$var$load("Wowvf"),
    $95813e40a91b94d6$var$load("4Nzvy"),
    $95813e40a91b94d6$var$load("h3ABO"),
    $95813e40a91b94d6$var$load("kC80R"),
    $95813e40a91b94d6$var$load("7EorR"),
    $95813e40a91b94d6$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("389X8", function(module, exports) {

let $2479d6e2ef182f20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2479d6e2ef182f20$var$load("e7ZUf"),
    $2479d6e2ef182f20$var$load("gL8bn"),
    $2479d6e2ef182f20$var$load("2YffH"),
    $2479d6e2ef182f20$var$load("lqFMg"),
    $2479d6e2ef182f20$var$load("4YQJ5"),
    $2479d6e2ef182f20$var$load("jwoNh"),
    $2479d6e2ef182f20$var$load("hJpvQ"),
    $2479d6e2ef182f20$var$load("l1nJ9"),
    $2479d6e2ef182f20$var$load("eBRUf"),
    $2479d6e2ef182f20$var$load("5eNHu"),
    $2479d6e2ef182f20$var$load("6iBAZ"),
    $2479d6e2ef182f20$var$load("h4Nf7"),
    $2479d6e2ef182f20$var$load("7f9Fz"),
    $2479d6e2ef182f20$var$load("8YSo7"),
    $2479d6e2ef182f20$var$load("g9CVe"),
    $2479d6e2ef182f20$var$load("djHM5"),
    $2479d6e2ef182f20$var$load("eJQji"),
    $2479d6e2ef182f20$var$load("6wr18"),
    $2479d6e2ef182f20$var$load("kjZZD"),
    $2479d6e2ef182f20$var$load("gizWr"),
    $2479d6e2ef182f20$var$load("4PUiY"),
    $2479d6e2ef182f20$var$load("dRpV3"),
    $2479d6e2ef182f20$var$load("ffEVr"),
    $2479d6e2ef182f20$var$load("dTsOE"),
    $2479d6e2ef182f20$var$load("jwTn5"),
    $2479d6e2ef182f20$var$load("aYdgM"),
    $2479d6e2ef182f20$var$load("jY21r"),
    $2479d6e2ef182f20$var$load("2vAWg"),
    $2479d6e2ef182f20$var$load("7cABH"),
    $2479d6e2ef182f20$var$load("7KZeZ"),
    $2479d6e2ef182f20$var$load("8Vzcw"),
    $2479d6e2ef182f20$var$load("co52j"),
    $2479d6e2ef182f20$var$load("bIPPg"),
    $2479d6e2ef182f20$var$load("2uVTT"),
    $2479d6e2ef182f20$var$load("hhss7"),
    $2479d6e2ef182f20$var$load("Wowvf"),
    $2479d6e2ef182f20$var$load("4Nzvy"),
    $2479d6e2ef182f20$var$load("h3ABO"),
    $2479d6e2ef182f20$var$load("kC80R"),
    $2479d6e2ef182f20$var$load("7EorR"),
    $2479d6e2ef182f20$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("5DHgn", function(module, exports) {

let $41b2276834372f71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41b2276834372f71$var$load("e7ZUf"),
    $41b2276834372f71$var$load("gL8bn"),
    $41b2276834372f71$var$load("2YffH"),
    $41b2276834372f71$var$load("lqFMg"),
    $41b2276834372f71$var$load("4YQJ5"),
    $41b2276834372f71$var$load("jwoNh"),
    $41b2276834372f71$var$load("l1nJ9"),
    $41b2276834372f71$var$load("eBRUf"),
    $41b2276834372f71$var$load("5eNHu"),
    $41b2276834372f71$var$load("6iBAZ"),
    $41b2276834372f71$var$load("h4Nf7"),
    $41b2276834372f71$var$load("7f9Fz"),
    $41b2276834372f71$var$load("8YSo7"),
    $41b2276834372f71$var$load("g9CVe"),
    $41b2276834372f71$var$load("djHM5"),
    $41b2276834372f71$var$load("eJQji"),
    $41b2276834372f71$var$load("6wr18"),
    $41b2276834372f71$var$load("kjZZD"),
    $41b2276834372f71$var$load("gizWr"),
    $41b2276834372f71$var$load("4PUiY"),
    $41b2276834372f71$var$load("dRpV3"),
    $41b2276834372f71$var$load("ffEVr"),
    $41b2276834372f71$var$load("dTsOE"),
    $41b2276834372f71$var$load("jwTn5"),
    $41b2276834372f71$var$load("aYdgM"),
    $41b2276834372f71$var$load("jY21r"),
    $41b2276834372f71$var$load("2vAWg"),
    $41b2276834372f71$var$load("7cABH"),
    $41b2276834372f71$var$load("7KZeZ"),
    $41b2276834372f71$var$load("8Vzcw"),
    $41b2276834372f71$var$load("co52j"),
    $41b2276834372f71$var$load("2uVTT"),
    $41b2276834372f71$var$load("hhss7"),
    $41b2276834372f71$var$load("Wowvf"),
    $41b2276834372f71$var$load("4Nzvy"),
    $41b2276834372f71$var$load("hJpvQ"),
    $41b2276834372f71$var$load("bIPPg"),
    $41b2276834372f71$var$load("lnKog"),
    $41b2276834372f71$var$load("h3ABO"),
    $41b2276834372f71$var$load("kC80R"),
    $41b2276834372f71$var$load("7EorR"),
    $41b2276834372f71$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("dwtzR", function(module, exports) {

let $9d8534fa6f8d217d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9d8534fa6f8d217d$var$load("2YffH"),
    $9d8534fa6f8d217d$var$load("lqFMg"),
    $9d8534fa6f8d217d$var$load("4YQJ5"),
    $9d8534fa6f8d217d$var$load("jwoNh"),
    $9d8534fa6f8d217d$var$load("l1nJ9"),
    $9d8534fa6f8d217d$var$load("eBRUf"),
    $9d8534fa6f8d217d$var$load("5eNHu"),
    $9d8534fa6f8d217d$var$load("6iBAZ"),
    $9d8534fa6f8d217d$var$load("h4Nf7"),
    $9d8534fa6f8d217d$var$load("7f9Fz"),
    $9d8534fa6f8d217d$var$load("8YSo7"),
    $9d8534fa6f8d217d$var$load("e7ZUf"),
    $9d8534fa6f8d217d$var$load("gL8bn"),
    $9d8534fa6f8d217d$var$load("g9CVe"),
    $9d8534fa6f8d217d$var$load("djHM5"),
    $9d8534fa6f8d217d$var$load("eJQji"),
    $9d8534fa6f8d217d$var$load("6wr18"),
    $9d8534fa6f8d217d$var$load("kjZZD"),
    $9d8534fa6f8d217d$var$load("gizWr"),
    $9d8534fa6f8d217d$var$load("4PUiY"),
    $9d8534fa6f8d217d$var$load("dRpV3"),
    $9d8534fa6f8d217d$var$load("ffEVr"),
    $9d8534fa6f8d217d$var$load("dTsOE"),
    $9d8534fa6f8d217d$var$load("jwTn5"),
    $9d8534fa6f8d217d$var$load("aYdgM"),
    $9d8534fa6f8d217d$var$load("jY21r"),
    $9d8534fa6f8d217d$var$load("2vAWg"),
    $9d8534fa6f8d217d$var$load("7cABH"),
    $9d8534fa6f8d217d$var$load("7KZeZ"),
    $9d8534fa6f8d217d$var$load("8Vzcw"),
    $9d8534fa6f8d217d$var$load("co52j"),
    $9d8534fa6f8d217d$var$load("2uVTT"),
    $9d8534fa6f8d217d$var$load("hhss7"),
    $9d8534fa6f8d217d$var$load("Wowvf"),
    $9d8534fa6f8d217d$var$load("4Nzvy"),
    $9d8534fa6f8d217d$var$load("hJpvQ"),
    $9d8534fa6f8d217d$var$load("bIPPg"),
    $9d8534fa6f8d217d$var$load("lnKog"),
    $9d8534fa6f8d217d$var$load("h3ABO"),
    $9d8534fa6f8d217d$var$load("kC80R"),
    $9d8534fa6f8d217d$var$load("7EorR"),
    $9d8534fa6f8d217d$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("fkS1Z", function(module, exports) {

let $b2a2a2b77dc03349$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b2a2a2b77dc03349$var$load("2YffH"),
    $b2a2a2b77dc03349$var$load("lqFMg"),
    $b2a2a2b77dc03349$var$load("4YQJ5"),
    $b2a2a2b77dc03349$var$load("jwoNh"),
    $b2a2a2b77dc03349$var$load("l1nJ9"),
    $b2a2a2b77dc03349$var$load("eBRUf"),
    $b2a2a2b77dc03349$var$load("5eNHu"),
    $b2a2a2b77dc03349$var$load("6iBAZ"),
    $b2a2a2b77dc03349$var$load("h4Nf7"),
    $b2a2a2b77dc03349$var$load("7f9Fz"),
    $b2a2a2b77dc03349$var$load("8YSo7"),
    $b2a2a2b77dc03349$var$load("e7ZUf"),
    $b2a2a2b77dc03349$var$load("gL8bn"),
    $b2a2a2b77dc03349$var$load("g9CVe"),
    $b2a2a2b77dc03349$var$load("djHM5"),
    $b2a2a2b77dc03349$var$load("eJQji"),
    $b2a2a2b77dc03349$var$load("6wr18"),
    $b2a2a2b77dc03349$var$load("kjZZD"),
    $b2a2a2b77dc03349$var$load("gizWr"),
    $b2a2a2b77dc03349$var$load("4PUiY"),
    $b2a2a2b77dc03349$var$load("dRpV3"),
    $b2a2a2b77dc03349$var$load("ffEVr"),
    $b2a2a2b77dc03349$var$load("dTsOE"),
    $b2a2a2b77dc03349$var$load("jwTn5"),
    $b2a2a2b77dc03349$var$load("aYdgM"),
    $b2a2a2b77dc03349$var$load("jY21r"),
    $b2a2a2b77dc03349$var$load("2vAWg"),
    $b2a2a2b77dc03349$var$load("7cABH"),
    $b2a2a2b77dc03349$var$load("7KZeZ"),
    $b2a2a2b77dc03349$var$load("8Vzcw"),
    $b2a2a2b77dc03349$var$load("co52j"),
    $b2a2a2b77dc03349$var$load("2uVTT"),
    $b2a2a2b77dc03349$var$load("hhss7"),
    $b2a2a2b77dc03349$var$load("Wowvf"),
    $b2a2a2b77dc03349$var$load("4Nzvy"),
    $b2a2a2b77dc03349$var$load("hJpvQ"),
    $b2a2a2b77dc03349$var$load("bIPPg"),
    $b2a2a2b77dc03349$var$load("lnKog"),
    $b2a2a2b77dc03349$var$load("h3ABO"),
    $b2a2a2b77dc03349$var$load("kC80R"),
    $b2a2a2b77dc03349$var$load("7EorR"),
    $b2a2a2b77dc03349$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("4jf5l", function(module, exports) {

let $3234a35d379a1cc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3234a35d379a1cc8$var$load("e7ZUf"),
    $3234a35d379a1cc8$var$load("gL8bn"),
    $3234a35d379a1cc8$var$load("2YffH"),
    $3234a35d379a1cc8$var$load("lqFMg"),
    $3234a35d379a1cc8$var$load("4YQJ5"),
    $3234a35d379a1cc8$var$load("jwoNh"),
    $3234a35d379a1cc8$var$load("hJpvQ"),
    $3234a35d379a1cc8$var$load("l1nJ9"),
    $3234a35d379a1cc8$var$load("eBRUf"),
    $3234a35d379a1cc8$var$load("5eNHu"),
    $3234a35d379a1cc8$var$load("6iBAZ"),
    $3234a35d379a1cc8$var$load("h4Nf7"),
    $3234a35d379a1cc8$var$load("7f9Fz"),
    $3234a35d379a1cc8$var$load("8YSo7"),
    $3234a35d379a1cc8$var$load("g9CVe"),
    $3234a35d379a1cc8$var$load("djHM5"),
    $3234a35d379a1cc8$var$load("eJQji"),
    $3234a35d379a1cc8$var$load("6wr18"),
    $3234a35d379a1cc8$var$load("kjZZD"),
    $3234a35d379a1cc8$var$load("gizWr"),
    $3234a35d379a1cc8$var$load("4PUiY"),
    $3234a35d379a1cc8$var$load("dRpV3"),
    $3234a35d379a1cc8$var$load("ffEVr"),
    $3234a35d379a1cc8$var$load("dTsOE"),
    $3234a35d379a1cc8$var$load("jwTn5"),
    $3234a35d379a1cc8$var$load("aYdgM"),
    $3234a35d379a1cc8$var$load("jY21r"),
    $3234a35d379a1cc8$var$load("2vAWg"),
    $3234a35d379a1cc8$var$load("7cABH"),
    $3234a35d379a1cc8$var$load("7KZeZ"),
    $3234a35d379a1cc8$var$load("8Vzcw"),
    $3234a35d379a1cc8$var$load("co52j"),
    $3234a35d379a1cc8$var$load("bIPPg"),
    $3234a35d379a1cc8$var$load("2uVTT"),
    $3234a35d379a1cc8$var$load("hhss7"),
    $3234a35d379a1cc8$var$load("Wowvf"),
    $3234a35d379a1cc8$var$load("4Nzvy"),
    $3234a35d379a1cc8$var$load("h3ABO"),
    $3234a35d379a1cc8$var$load("kC80R"),
    $3234a35d379a1cc8$var$load("7EorR"),
    $3234a35d379a1cc8$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("eyi3k", function(module, exports) {

let $a9823e8b29b84b51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a9823e8b29b84b51$var$load("e7ZUf"),
    $a9823e8b29b84b51$var$load("gL8bn"),
    $a9823e8b29b84b51$var$load("2YffH"),
    $a9823e8b29b84b51$var$load("lqFMg"),
    $a9823e8b29b84b51$var$load("4YQJ5"),
    $a9823e8b29b84b51$var$load("jwoNh"),
    $a9823e8b29b84b51$var$load("l1nJ9"),
    $a9823e8b29b84b51$var$load("eBRUf"),
    $a9823e8b29b84b51$var$load("5eNHu"),
    $a9823e8b29b84b51$var$load("6iBAZ"),
    $a9823e8b29b84b51$var$load("h4Nf7"),
    $a9823e8b29b84b51$var$load("7f9Fz"),
    $a9823e8b29b84b51$var$load("8YSo7"),
    $a9823e8b29b84b51$var$load("g9CVe"),
    $a9823e8b29b84b51$var$load("djHM5"),
    $a9823e8b29b84b51$var$load("eJQji"),
    $a9823e8b29b84b51$var$load("6wr18"),
    $a9823e8b29b84b51$var$load("kjZZD"),
    $a9823e8b29b84b51$var$load("gizWr"),
    $a9823e8b29b84b51$var$load("4PUiY"),
    $a9823e8b29b84b51$var$load("dRpV3"),
    $a9823e8b29b84b51$var$load("ffEVr"),
    $a9823e8b29b84b51$var$load("dTsOE"),
    $a9823e8b29b84b51$var$load("jwTn5"),
    $a9823e8b29b84b51$var$load("aYdgM"),
    $a9823e8b29b84b51$var$load("jY21r"),
    $a9823e8b29b84b51$var$load("2vAWg"),
    $a9823e8b29b84b51$var$load("7cABH"),
    $a9823e8b29b84b51$var$load("7KZeZ"),
    $a9823e8b29b84b51$var$load("8Vzcw"),
    $a9823e8b29b84b51$var$load("co52j"),
    $a9823e8b29b84b51$var$load("2uVTT"),
    $a9823e8b29b84b51$var$load("hhss7"),
    $a9823e8b29b84b51$var$load("Wowvf"),
    $a9823e8b29b84b51$var$load("4Nzvy"),
    $a9823e8b29b84b51$var$load("hJpvQ"),
    $a9823e8b29b84b51$var$load("bIPPg"),
    $a9823e8b29b84b51$var$load("lnKog"),
    $a9823e8b29b84b51$var$load("h3ABO"),
    $a9823e8b29b84b51$var$load("kC80R"),
    $a9823e8b29b84b51$var$load("7EorR"),
    $a9823e8b29b84b51$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("frKvj", function(module, exports) {

let $b3ed735b0530d907$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b3ed735b0530d907$var$load("e7ZUf"),
    $b3ed735b0530d907$var$load("gL8bn"),
    $b3ed735b0530d907$var$load("2YffH"),
    $b3ed735b0530d907$var$load("lqFMg"),
    $b3ed735b0530d907$var$load("4YQJ5"),
    $b3ed735b0530d907$var$load("jwoNh"),
    $b3ed735b0530d907$var$load("l1nJ9"),
    $b3ed735b0530d907$var$load("eBRUf"),
    $b3ed735b0530d907$var$load("5eNHu"),
    $b3ed735b0530d907$var$load("6iBAZ"),
    $b3ed735b0530d907$var$load("h4Nf7"),
    $b3ed735b0530d907$var$load("7f9Fz"),
    $b3ed735b0530d907$var$load("8YSo7"),
    $b3ed735b0530d907$var$load("g9CVe"),
    $b3ed735b0530d907$var$load("djHM5"),
    $b3ed735b0530d907$var$load("eJQji"),
    $b3ed735b0530d907$var$load("6wr18"),
    $b3ed735b0530d907$var$load("kjZZD"),
    $b3ed735b0530d907$var$load("gizWr"),
    $b3ed735b0530d907$var$load("4PUiY"),
    $b3ed735b0530d907$var$load("dRpV3"),
    $b3ed735b0530d907$var$load("ffEVr"),
    $b3ed735b0530d907$var$load("dTsOE"),
    $b3ed735b0530d907$var$load("jwTn5"),
    $b3ed735b0530d907$var$load("aYdgM"),
    $b3ed735b0530d907$var$load("jY21r"),
    $b3ed735b0530d907$var$load("2vAWg"),
    $b3ed735b0530d907$var$load("7cABH"),
    $b3ed735b0530d907$var$load("7KZeZ"),
    $b3ed735b0530d907$var$load("8Vzcw"),
    $b3ed735b0530d907$var$load("co52j"),
    $b3ed735b0530d907$var$load("2uVTT"),
    $b3ed735b0530d907$var$load("hhss7"),
    $b3ed735b0530d907$var$load("Wowvf"),
    $b3ed735b0530d907$var$load("4Nzvy"),
    $b3ed735b0530d907$var$load("hJpvQ"),
    $b3ed735b0530d907$var$load("bIPPg"),
    $b3ed735b0530d907$var$load("lnKog"),
    $b3ed735b0530d907$var$load("h3ABO"),
    $b3ed735b0530d907$var$load("kC80R"),
    $b3ed735b0530d907$var$load("7EorR"),
    $b3ed735b0530d907$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lk93G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lk93G", function(module, exports) {

let $f8627e0aeed3fccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8627e0aeed3fccf$var$load("hJpvQ"),
    $f8627e0aeed3fccf$var$load("bIPPg"),
    $f8627e0aeed3fccf$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $h82at.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $1cfRh.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.21c80746.js.map
